package com.eladfinish.bible.contest.screens.main.usecases

import com.eladfinish.bible.contest.appcontent.AppLinks
import com.eladfinish.bible.contest.repository.remoteConfig.RemoteConfig
import com.eladfinish.bible.contest.usecase.GetRemoteConfigValueUseCase

/**
 * The address the main screen's Telegram button opens. It is [AppLinks.TELEGRAM_CHANNEL_URL]
 * unless Remote Config carries another one: a channel's address can be renamed, and installed
 * versions would otherwise keep opening the old one until they update.
 */
class GetTelegramChannelUrlUseCase(
    private val getRemoteConfigValueUseCase: GetRemoteConfigValueUseCase,
) {

    operator fun invoke(): String = resolveTelegramChannelUrl(
        remoteValue = runCatching {
            getRemoteConfigValueUseCase.get<String>(RemoteConfig.TELEGRAM_CHANNEL_URL)
        }.getOrNull(),
    )
}

/** A remote value is used only when it is a Telegram link, so a typo in the console cannot send users elsewhere. */
internal fun resolveTelegramChannelUrl(remoteValue: String?): String {
    val url = remoteValue?.trim().orEmpty()
    val path = url.removePrefix(TELEGRAM_LINK_PREFIX)
    val isTelegramLink = url.startsWith(TELEGRAM_LINK_PREFIX) && path.isNotEmpty() && path.none { it.isWhitespace() }
    return if (isTelegramLink) url else AppLinks.TELEGRAM_CHANNEL_URL
}

private const val TELEGRAM_LINK_PREFIX = "https://t.me/"
